<template>
    <div id="cloud" class="cloud">
        <section id="cloud-entry-wrap" class="cloud-entry-wrap">
            <div class="cloud-entry">
                <div class="container">
                    <div class="cloud-logo"><img :src="CloudLogo" alt=""></div>
                    <h1 class="title">{{ $t( 'homepage.entryTitle' ) }}</h1>
                    <p class="subtitle">{{ $t( 'homepage.entrySubTitle' ) }}</p>
                    <div
                        v-show="userId !== null"
                        :class="['entry-box', userId ? 'is-login' : 'no-login']">
                        <div>
                            <reo-common-button
                                v-show="!userId"
                                :label=" $t( 'homepage.btnLogin' )"
                                @click="handleLogin"
                                class='login-btn'
                                :custom-width="!isMobile?200:undefined"
                            />
                            <reo-common-button
                                v-show="userId"
                                :label="$t( 'homepage.cloud_library' )"
                                @click="()=> navigateTo('library')"
                                class='library-btn'
                                :custom-width="!isMobile?400:undefined"
                                ga-label="My Cloud Library"
                            />
                        </div>
                        <reo-common-button
                            :label="$t( 'homepage.btnDredge' )"
                            @click="handleSignup"
                            class='signup-btn'
                            colorType="light"
                            :custom-width="!isMobile?200:undefined"
                        />
                    </div>
                    <div
                        :style="anchorStyle"
                        class="jump-to"
                        @click="goAnchor"
                    >
                        <p>{{ $t('homepage.seePlan') }}</p>
                        <span class="icon-icon_arrow-down"></span>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import CloudLogo from 'IMAGE/homepage/cloud-logo.png';
import { config } from 'CONFIG';
import paymentMethods from '@/config/paymentMethods';
import router from '@/router';
import ReoCommonButton from '@/components/ReoCommonButton.vue';
import { getRedirectUrl } from '@/common/js/url';
import reolinkGa from '@/common/js/gtagPageview';

export default Vue.extend({

    components: {
        ReoCommonButton
    },

    data () {

        return {

            planList: [] as any[],
            paymentMethods,
            config,
            CloudLogo,

        };

    },

    methods: {

        goAnchor () {

            document.querySelector( '#sub-part' )!.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });

        },
        async navigateTo( btnType: 'login' | 'signup' | 'library' ) {

            switch ( btnType ) {

                case 'login':{

                    window.location.href = this.loginDashboardUrl;
                    break;

                }
                case 'signup':{

                    window.location.href = this.signupUrl;
                    break;

                }
                case 'library':{

                    try {

                        await router.push({
                            name: 'library'
                        });

                    } catch ( error ) {

                        console.error( error );

                    }

                    break;

                }

            }

        },
        async handleLogin() {

            reolinkGa.sendSimpleEvent( 'cloud-log in' );
            await this.navigateTo( 'login' );

        },
        async handleSignup() {

            reolinkGa.sendSimpleEvent( 'cloud-sign up' );
            await this.navigateTo( 'signup' );

        }

    },

    computed: {

        loginDashboardUrl () {

            return config.accountCenterLoginUrl + '?redirect=' + getRedirectUrl( '/user/cloud-library/' );

        },

        signupUrl () {

            return config.accountCenterLoginUrl + '?redirect=' + getRedirectUrl( '/user/cloud-library/' ) + '#signup';

        },

        userId(): boolean {

            return this.$store.getters.userId;

        },

        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },

        lang(): string  {

            return this.$store.getters.lang;

        },

        userStatus (): string {

            return this.$store.state.user.status;

        },

        anchorStyle(): Record<string, string> {

            return { 'visibility': this.$route.name === 'cloud-plan' ? 'visible' : 'hidden' };

        }

    }

});

</script>

<style scoped rel="stylesheet/css" lang="less">

.cloud {
    color: #333;
    text-align: center;
    font-weight: 400;
    line-height: 1.2;
    .cloud-entry {
        padding: 60px 0 0;
        background: url(IMAGE/homepage/subscribe-email-bg.jpg) #f3f4f9 top
            center no-repeat;

        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0;
            position: relative;
            .cloud-logo {
                margin-bottom: 0.2rem;
                img {
                    height: 50px;
                }
            }
            .title {
                font-size: 60px;
                font-weight: 600;
                margin-bottom: 0.2rem;
            }
            .subtitle,.date {
                font-size: 0.24rem;
            }
            .entry-box {
                margin-top: 40px;
                display: flex;
                justify-content: center;
                gap: 20px;
                &.is-login div+div {
                    display: none;
                }
            }

            .jump-to {
                color: @theme;
                cursor: pointer;
                margin-top: 0.4rem;
                display: inline-block;
                font-size: 0.18rem;
                &>p{
                    font-weight: 500;
                    margin-bottom: 0.16rem;
                }
                @media @mobile {
                    font-size: 0.26rem;
                }
            }
        }
    }

}

@media @mobile {
    .cloud{
        .cloud-entry{
            padding: 0.5rem .3rem 0.47rem;
            background: url(IMAGE/homepage/subscribe-email-bg-m.jpg) #f3f4f9
            top center no-repeat;
            background-size: 100% auto;
            .container{

                .cloud-logo {
                    display: block;
                    img {
                        display: block;
                        margin: 0 auto;
                        max-width: 80px;
                        width: 0.8rem;
                        height: auto;
                    }
                }
                .title {
                    margin-top: 0.28rem;
                    font-size: 0.64rem;
                }
                .subtitle,.date{
                    margin-top: 0.22rem;
                    font-size: 0.32rem;
                }
                .subtitle{
                    line-height: 1.2;
                }
                .entry-box {
                    margin-top: 24px;
                    flex-direction: column;
                    div {
                        display: block;
                    }
                }
            }
        }
    }
}

/* entry --E */

</style>
